import { render, staticRenderFns } from "./LogBook.vue?vue&type=template&id=5e01f9a1"
import script from "./LogBook.vue?vue&type=script&lang=js"
export * from "./LogBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports